/* eslint-disable react/display-name */
import React from 'react';

import View from './View';
import { useViewModel } from './viewModel';
import * as seeAllPrerenderFunctions from '../../pages/see-all/[pageId]/[sectionId]';
import getSeeAllScreenStyles from './styles/index.web';
import { SeeAllScreenProps } from './types';
import { createWebHeaderProps } from '../../utils/headerUtils';

export const SeeAllScreen = {
    Main: (props: SeeAllScreenProps) => {
        const viewModelProps = useViewModel(props);

        // Create web header props using our utility function
        const webHeaderProps = createWebHeaderProps(
            viewModelProps.assetsLabel || undefined, // Use playlist title as header title
            viewModelProps.assetsLabel ?? 'Back', // Use playlist title or 'Back' as back button title
            '' // Empty fallback (will result in 'Back' for backButtonTitle)
        );

        return <View {...viewModelProps} {...webHeaderProps} />;
    },
    View,
    useViewModel,
    page: {
        'see-all': {
            '[pageId]': {
                '[sectionId]': seeAllPrerenderFunctions,
            },
        },
    },
    // default styles getter
    getDefaultStyles: getSeeAllScreenStyles,
};

// For backward compatibility
export default SeeAllScreen;
